import {
  MaterialGroup,
  SHEET_STACKING_OPTIONS,
  SheetStackingType,
} from '@cutr/constants/cutlist';
import { useTranslation } from 'react-i18next';

import { Dropdown } from '@/primitives/Dropdown';
import { Icon, SheetEdgeTrimNoSide, Yep } from '@/primitives/Icons';

import styles from './dropdown.module.css';

export const SheetStackingDropdown = ({
  group,
  onSheetStackingUpdate,
}: {
  group: MaterialGroup;
  onSheetStackingUpdate: (sheetStackingType: SheetStackingType) => void;
}) => {
  const { t } = useTranslation();

  const options = Object.values(SHEET_STACKING_OPTIONS).map(
    (sheetStackingType) => ({
      sheetStackingType,
      label: t(`cutlist-form.sheetStackingType.${sheetStackingType}`),
      isSelected: group.sheetStackingType === sheetStackingType,
    })
  );

  return (
    <Dropdown
      id={`sheet-stacking-${group.id}`}
      onSelected={(value) => onSheetStackingUpdate(value as SheetStackingType)}
      options={options.map((option) => {
        return {
          value: option.sheetStackingType,
          selected: option.isSelected,
          component: ({ isSelected }) => (
            <SheetStackingItem label={option.label} isSelected={isSelected} />
          ),
        };
      })}
    />
  );
};

export const SheetStackingItem = ({
  label,
  isSelected,
}: {
  label: string;
  isSelected?: boolean;
}) => {
  return (
    <div className={styles.dropdownItem}>
      <div>
        <Icon
          style={{
            visibility: 'hidden',
            width: 0,
          }}
          icon={<SheetEdgeTrimNoSide />}
          size={4}
        />
      </div>

      <div className={styles.dropdownName}>
        <div>
          <strong>{label}</strong>
        </div>
      </div>
      <div>{isSelected && <Icon icon={<Yep />} />}</div>
    </div>
  );
};
